export class ContentServer {
  public static defaults = 'beta';
  public static envs = {
    development: 'https://kellis-content-server.beta.saybot.net',
    beta: 'https://kellis-content-server.beta.saybot.net',
    staging: 'https://kellis-content-server.staging.saybot.net',
    production: 'https://content-api-bak1.alo7.com', //? 略猥琐
  };

  public static get(inKey) {
    const envs = this.envs;
    return envs[inKey] || envs[this.defaults];
  }
}
